/**
 * Game Core
 * 
 * Shared interfaces, types, and utility functions used across
 * all game modes and core systems.
 */

/**
 * Game statistics tracked across all modes
 */
export interface GameStats {
    score: number
    // TODO: Remove deprecated score-based level system (GitHub Issue #36)
    // This field is no longer used for gameplay mechanics. Game modes now use:
    // - Endless: time-based level (every 45s) via getTimeBasedLevel()
    // - Time Attack: fixed difficulty level 3
    level: number  // DEPRECATED: Score-based level calculation (legacy, not used for gameplay)
    totalCellsCleared: number
    longestChain: number
    timeElapsed: number
    pairsDropped: number
}

/**
 * Base game configuration (can be extended by modes)
 */
export interface GameConfig {
    initialFallSpeed: number
    speedIncreaseRate: number
}

/**
 * Mode identifier enum
 */
export enum GameMode {
    ENDLESS = 'endless',
    TIME_ATTACK = 'timeAttack',
    PUZZLE = 'puzzle',
    CLASSIC = 'classic'
}

/**
 * Default game configuration
 */
export const DEFAULT_GAME_CONFIG: GameConfig = {
    initialFallSpeed: 1000,
    speedIncreaseRate: 50
}

/**
 * Create default game statistics
 */
export function createDefaultStats(): GameStats {
    return {
        score: 0,
        level: 1,
        totalCellsCleared: 0,
        longestChain: 0,
        timeElapsed: 0,
        pairsDropped: 0
    }
}

/**
 * Merge partial config with defaults
 */
export function mergeConfig(
    defaults: GameConfig,
    partial?: Partial<GameConfig>
): GameConfig {
    return {
        ...defaults,
        ...partial
    }
}
